import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'outcomesGCSummaryTable',
    label: 'Outcomes Summary Table',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
